import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../components/CustomButtons/Button";
import DialogContent from "@mui/material/DialogContent";
import CustomInput from "../../../components/CustomInput/CustomInput";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import { Close } from "@mui/icons-material";
import { FormLabel, MenuItem, Select } from "@mui/material";
import GridItem from "../../../components/Grid/GridItem";
import GridContainer from "../../../components/Grid/GridContainer";
import SaveButton from "../../../components/CustomInput/SaveButton";

import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

const New = ({ classes, open, toggle }) => {
  const [saving, setSaving] = useState(false);
  const [vestigingsNaam, setVestigingsNaam] = useState("");
  const [salesareaType, setSalesareaType] = useState(null);

  const navigate = useNavigate();

  const save = () => {
    setSaving(true);

    let formData = new FormData();

    formData.append("naam", vestigingsNaam);
    formData.append("salesarea_type", salesareaType);

    axios.post("core/vestigingen", formData).then((response) => {
      setSaving(false);
      toggle();
      let url = "/manager/vestigingen/" + response.data.data.id + "/edit";
      navigate(url);
    });
  };

  const disableSave = () => {
    return vestigingsNaam === "" || salesareaType == null;
  };

  const handleVestigingsNaam = (event) => {
    setVestigingsNaam(event.target.value);
  };

  return (
    <Dialog
      TransitionComponent={Transition}
      aria-describedby={"notice-modal-slide-description"}
      aria-labelledby={"notice-modal-slide-title"}
      fullWidth
      keepMounted
      maxWidth={"lg"}
      onClose={toggle}
      open={open}
    >
      <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
        <Button
          aria-label={"Close"}
          className={classes.modalCloseButton}
          color={"transparent"}
          justIcon
          key={"close"}
          onClick={toggle}
        >
          <Close className={classes.modalClose} />
        </Button>
        <h4 className={classes.modalTitle}>
          <TranslationWrapper tDefault={"Maak nieuwe vestiging aan"} tKey={"vestigingen.modal.new.title"} />
        </h4>
      </DialogTitle>
      <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
        <GridContainer>
          <GridItem sm={2} xs={12}>
            <FormLabel className={classes.labelHorizontal}>
              <TranslationWrapper tDefault={"Vestigingnaam"} tKey={"vestigingen.modal.new.form.naam"} />
            </FormLabel>
          </GridItem>
          <GridItem sm={10} xs={12}>
            <CustomInput
              formControlProps={{
                fullWidth: true,
              }}
              id={"naam"}
              inputProps={{
                type: "text",
                name: "naam",
                onChange: handleVestigingsNaam,
              }}
            />
          </GridItem>
          <GridItem sm={2} xs={12}>
            <FormLabel className={classes.labelHorizontal}>
              <TranslationWrapper tDefault={"Product solution"} tKey={"vestigingen.modal.new.form.salesareaType"} />
            </FormLabel>
          </GridItem>
          <GridItem sm={10} xs={12}>
            <Select
              color={"primary"}
              onChange={(e) => {
                setSalesareaType(e.target.value);
              }}
              style={{ width: "100%" }}
            >
              <MenuItem value={"QR"}>
                <TranslationWrapper tDefault={"QR"} tKey={"productSolution.QR"} />
              </MenuItem>
              <MenuItem value={"PICKUP_DELIVERY"}>
                <TranslationWrapper tDefault={"Pickup delivery webshop"} tKey={"productSolution.PICKUP_DELIVERY"} />
              </MenuItem>
              <MenuItem value={"KIOSK"}>
                <TranslationWrapper tDefault={"Kiosk"} tKey={"productSolution.KIOSK"} />
              </MenuItem>
              <MenuItem value={"TABLET"}>
                <TranslationWrapper tDefault={"Tablet"} tKey={"productSolution.TABLET"} />
              </MenuItem>
              <MenuItem value={"CATALOG"}>
                <TranslationWrapper tDefault={"Digital menu"} tKey={"productSolution.CATALOG"} />
              </MenuItem>
            </Select>
          </GridItem>
        </GridContainer>
      </DialogContent>

      <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
        <SaveButton
          buttonText={<TranslationWrapper tDefault={"Aanmaken"} tKey={"vestigingen.modal.new.form.savebutton.text"} />}
          disabled={disableSave()}
          onClick={save}
          saving={saving}
        />
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(New, notificationsStyle);
